module.exports = __webpack_public_path__ + "static/media/gestionadas3.98be72de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/gestionadas3.svg
// module id = 313
// module chunks = 0